
import React, { useState } from 'react';
import './index.css';
import './App.css'
import homeMain from './img/liver-transplantation-02.webp'
import qrCode from './img/qr-code.jpeg'
import liverLogo from './img/liver-logo.webp'
import sampatRahane from './img/sampat-rahane-p.jpeg'



const translations = {
  marathi: {
    headerText: 'जीवन वाचवण्यासाठी मदत करा',
    content: 'ही मराठीत काही यादृच्छिक मजकूर आहे.',
    cardTextHeading: '💔 एका बापाचे प्राण वाचवण्यासाठी तुमची थोडीशी मदतही अमूल्य ठरू शकते',
    cardText: `संपत नामदेव रहाणे गाव - चंदनापुरी , संगमनेर. व्यवसाय - शेती. वय - ५४.
    आमचे वडील २०१९ पासून(हिपॅटायटीस बी)लिव्हर सिरोसिस या आजाराशी लढत असुन कोणत्याही प्रकारचे व्यसन नसताना त्यांचे लिव्हर खराब झाले आहे. 
आतापर्यंत १८ ते १९ लाख रुपये खर्च झाले असून मेडिकवर हॉस्पिटल पुणे  येथे ऊपचार चालू आहेत. लिव्हर प्रत्यारोपण साठी २५ ते ३० लाख रुपये खर्च आहे.
आपली छोटीशी मदत एक शेतकऱ्याचे प्राण वाचऊ शकते.
खाली दिलेल्या लिंक मध्ये हॉस्पिटल चे सर्व ओरीजनल डॉक्युमेंट व स्कॅनर दिलेले आहे.
    तुमचे अगदी छोटेसे मदत त्यांच्या जगण्याचा मार्ग उजळवू शकते. तुमची दयाळूपणा एक जीव वाचवू शकते, आणि मुलांना त्यांचे वडील परत देऊ शकते.`,
    cardTextOne: `कुटुंब त्याचा जीव वाचवण्यासाठी हताशपणे संघर्ष करत आहे. वेळ निघून चालली आहे, आणि प्रत्येक क्षण त्यांना त्याला गमावण्याच्या जवळ आणत आहे. दुःख आणि हतबलतेचे ओझे त्यांच्या हृदयावर जड झाले आहे, तरीही ते आशेवर टिकून आहेत. आपले समर्थन त्यांना लढत राहण्यासाठी आधार ठरू शकते. कृपया, या संकटकाळात पुढे येऊन त्यांना मदत करा.`,
    cardTextbottom: `🙏 कृपया, एखाद्याला जीवनाची दुसरी संधी देण्याचे कारण व‍हा. प्रत्येक रुपया महत्त्वाचा आहे.`,
    viewButton: 'लिव्हर ट्रान्सप्लांट कागदपत्रे पाहा',
    lookingForHelpDate: 'मदत बघण्यासाठी सुरू केलेली तारीख 08/07/2025',
    lastDate: 'डॉक्टरांनी दिलेला वेळ  08/11/2025',
    downloadButton: 'लिव्हर ट्रान्सप्लांट कागदपत्रे डाउनलोड करा',
    tableHeading: 'लिव्हर ट्रान्सप्लांटसाठी मदत करणाऱ्या लोकांची यादी',
    tableColOne: 'मदत करणाऱ्याचे नाव ',
    tableColTwo: 'मदत केलेली तारीख',
    tableColThree: 'रक्कम',
    totalLabel: 'एकूण दिलेली रक्कम',
    startingDate: 'मदत मागण्याची सुरुवात केलेली तारीख 10/07/25'

  },
  hindi: {
    headerText: ' जीवन रक्षक ट्रांसप्लांट के लिए मदत करे',
    content: 'यह हिंदी में कुछ यादृच्छिक पाठ है।',
    cardTextHeading: '💔 एक पिता जीवन और मृत्यु के बीच जूझ रहे हैं — आपकी मदद उनका सहारा बन सकती है',
    cardText: `संपत नामदेव रहाणे, 54 वर्षीय पिता, अपने जीवन के लिए संघर्ष कर रहे हैं। उन्हें तत्काल लीवर ट्रांसप्लांट की आवश्यकता है, जिसकी लागत ₹25 लाख है — यह राशि उनके संघर्षशील, आर्थिक रूप से गरीब परिवार के लिए असंभव है।

पिछले 5 वर्षों से लीवर का इलाज चल रहा है। गरीब स्थिति और पहले ही बहुत खर्च हो चुका है, इसलिए बड़ी राशि जमा करना बहुत मुश्किल है। डॉक्टर ने कहा है कि उनके पास केवल 4 महीने का समय है।

वह सिर्फ एक मरीज नहीं हैं — वह एक पिता, हैं। उनकी बच्चे सब कुछ कर रहे हैं, लेकिन उन्हें आपकी मदद की जरूरत है। कल्पना करें कि आपके प्रियजन के पास सर्जरी के बिना केवल 4 महीने बचे हैं। आपका दान इसे बदल सकता है।

आपका सबसे छोटा दान भी उनके जीवित रहने का रास्ता रोशन कर सकता है। आपकी दया एक जीवन बचा सकती है, एक परिवार को पूरा रख सकती है, और बच्चों को उनका पिता वापस दे सकती है।`,
    cardTextOne: `परिवार उसकी जान बचाने के लिए बेताबी से संघर्ष कर रहा है। समय हाथ से निकलता जा रहा है, और हर गुजरता पल उन्हें उसे खोने के करीब ले जा रहा है। दुख और लाचारी का बोझ उनके दिल पर भारी पड़ रहा है, फिर भी वे उम्मीद से चिपके हुए हैं। आपका सहारा उनकी जंग को जारी रखने की ताकत बन सकता है। कृपया, इस मुश्किल वक्त में आगे बढ़कर उनकी मदद करें।`,
    cardTextbottom: `🙏 कृपया, किसी को जीवन का दूसरा मौका देने का कारण बनें। हर रुपया मायने रखता है।`,
    viewButton: 'लीवर ट्रांसप्लांट दस्तावेज़ देखे',
    lookingForHelpDate: 'मदत बघण्यासाठी सुरू केलेली तारीख 08/07/2025',
    lastDate: 'डॉक्टरांनी दिलेला वेळ  08/11/2025',
    downloadButton: 'लीवर ट्रांसप्लांट दस्तावेज़ डाउनलोड करें',
    tableHeading: 'लीवर ट्रांसप्लांट में मदद करने वाले लोगों की सूची',
    tableColOne: 'मदद करने वाले का नाम',
    tableColTwo: 'मदद की तारीख',
    tableColThree: 'राशि',
    totalLabel: 'कुल दान की राशि',
    startingDate: 'मदद माँगना कब शुरू किया 10/07/25'
  },
  english: {
    headerText: 'A Liver Transplant is Her Only Hope',
    content: 'This is some random text in English.',
    cardTextHeading: '💔 A Father’s Life Is Hanging by a Thread — You Can Be His Hope',
    cardText: `Sampat Namdev Rahane, a 54-year-old father, is battling for his life. He urgently needs a liver transplant that costs ₹25 lakhs — an amount impossible for his struggling, financially poor family to bear.

     For the past 5 years, he has been undergoing liver treatment, but the costs have been overwhelming. His family, already in a dire financial situation, has exhausted their resources, making it nearly impossible to raise the large sum needed for the transplant. The doctors have given him only 4 months to live without the surgery.

He’s not just a patient — he’s a father, a human being holding on to hope. His children are doing everything they can, but they need your help. Imagine the pain of knowing your loved one has only 4 months left without the surgery. Your donation can change that.

Even the smallest donation from you can light the path to survival. Your kindness can save a life, keep a family whole, and give children their father back..`,
    cardTextbottom: `🙏 Please, be the reason someone gets another chance at life. Every rupee counts.`,
    cardTextOne: `The family is in a desperate struggle to save his life. Time is slipping away, and every passing moment brings them closer to losing him. The burden of grief and helplessness weighs heavily on their hearts, yet they cling to hope. Your support could be the lifeline they need to keep fighting. Please, step forward and help them in this critical time.`,
    lookingForHelpDate: 'मदत बघण्यासाठी सुरू केलेली तारीख 08/07/2025',
    lastDate: 'डॉक्टरांनी दिलेला वेळ  08/11/2025',
    viewButton: 'View Liver Transplant Documents',
    downloadButton: 'Download Liver Transplant Documents',
    tableHeading: 'Supporters Who Helped in Liver Transplant Case',
    tableColOne: `Helper's Name`,
    tableColTwo: 'Helped On',
    tableColThree: 'Amount ',
    totalLabel: 'Total Donated Amount',
    startingDate: 'Date when we started seeking help 10/07/25'

  },
};

// const donationData = [
//   {
//     name: {
//       english: '-------',
//       hindi: '-------',
//       marathi: '-------',
//     },
//     date: '',
//     amount: 0,
//   },
//   // {
//   //   name: {
//   //     english: 'Ravi Patil',
//   //     hindi: 'रवि पाटिल',
//   //     marathi: 'रवि पाटील',
//   //   },
//   //   date: '2025-07-06',
//   //   amount: 1500,
//   // },
//   // {
//   //   name: {
//   //     english: 'Sneha Joshi',
//   //     hindi: 'स्नेहा जोशी',
//   //     marathi: 'स्नेहा जोशी',
//   //   },
//   //   date: '2025-07-07',
//   //   amount: 750,
//   // },
// ];

const contactTranslations = {
  english: {
    title: 'Contact Details',
    father: 'Sampat Namdev Rahane',
    son: 'Rahul Sampat Rahane (Son)',
    sonOne: 'pravin Sampat Rahane (Son)',
    phoneLabel: 'Phone Number',
  },
  hindi: {
    title: 'संपर्क विवरण',
    father: 'सम्पत नामदेव रहाणे',
    son: 'राहुल सम्पत रहाणे (पुत्र)',
    sonOne: 'प्रविण  संपत रहाणे (मुलगा)',
    phoneLabel: 'फ़ोन नंबर',
  },
  marathi: {
    title: 'संपर्क तपशील',
    father: 'संपत नामदेव रहाणे',
    son: 'राहुल संपत रहाणे (मुलगा)',
    sonOne: 'प्रविण  संपत रहाणे (मुलगा)',
    phoneLabel: 'फोन नंबर',
  },
};

function App() {
  const [language, setLanguage] = useState('marathi');

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  // const totalAmount = donationData.reduce((sum, donor) => sum + donor.amount, 0);

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      <header className="w-full flex items-center justify-between bg-white shadow p-4 rounded-md">
        <div className="flex items-center space-x-2">
          <img src={liverLogo} alt="Logo" className="w-10 h-10" />
        </div>
        <div className="text-lg font-semibold text-center">{translations[language].headerText}</div>
        <div>
          <select value={language} onChange={handleLanguageChange} className="border border-gray-300 rounded-md px-3 py-1 focus:outline-none">
            <option value="marathi">मराठी</option>
            <option value="hindi">हिंदी</option>
            <option value="english">English</option>
          </select>
        </div>
      </header>
      <div className='mx-2 md:mx-12 flex flex-col gap-4'>
        <div className="flex flex-wrap shadow-lg my-8">
          <div className="w-full sm:w-1/2 lg:w-1/3 flex">
            <img src={sampatRahane} alt="sampat Rahane" title="petient" className="object-cover w-full h-[70vh]" />
          </div>

          <div className="w-full sm:w-1/2 lg:w-2/3 p-4 my-auto text-left">
            <div className="whitespace-nowrap text-xl font-semibold flex items-center gap-2">
              <span className='textWrap'>{translations[language].cardTextHeading}</span>
            </div>
            <div className="text-justify mt-4 p-2 leading-relaxed" title="">
              {translations[language].cardText}
            </div>
            <div className="whitespace-nowrap text-xl font-semibold flex items-center gap-2">
              <span className='textWrap'  >{translations[language].cardTextbottom}</span>
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row sm:justify-center sm:gap-4 gap-2 items-center my-4">
          <button
            type="button"
            onClick={() => window.open('./liver-transplant-documents.pdf', '_blank')}
            className="w-full sm:w-auto focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
          >
            {translations[language].viewButton}
          </button>

          <a href="/liver-transplant-documents.pdf" download className="w-full sm:w-auto">
            <button
              type="button"
              className="w-full sm:w-auto focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
            >
              {translations[language].downloadButton}
            </button>
          </a>
        </div>

        {/* <div>
          <h2 className='font-bold text-2xl text-center mb-4'> {translations[language].tableHeading}</h2>
          <hr />
          <div class="relative overflow-x-auto">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" class="px-6 py-3">
                    {translations[language].tableColOne}
                  </th>
                  <th scope="col" class="px-6 py-3">
                    {translations[language].tableColTwo}
                  </th>
                  <th scope="col" class="px-6 py-3">
                    {translations[language].tableColThree}
                  </th>
                </tr>
              </thead>
              <tbody>
                {donationData.map((donor, index) => (
                  <tr key={index} className="bg-white border-b">
                    <td className="px-6 py-4 font-medium">{donor.name[language]}</td>
                    <td className="px-6 py-4">
                      {new Date(donor.date).toLocaleDateString(
                        language === 'marathi' ? 'mr-IN' : language === 'hindi' ? 'hi-IN' : 'en-IN'
                      ) }
                    </td>
                    <td className="px-6 py-4">₹{donor.amount.toLocaleString('en-IN')}</td>
                  </tr>
                ))}
                <tr className="bg-gray-100 font-semibold border-t">
                  <td className="px-6 py-4 text-green-700" colSpan={2}>
                    {translations[language].totalLabel}
                  </td>
                  <td className="px-6 py-4 text-green-700">
                    ₹{totalAmount.toLocaleString('en-IN')}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> */}
        <div className="flex flex-wrap shadow-lg p-4">
          <div className="w-full sm:w-1/2 lg:w-2/3 p-4 my-2 text-left">
            <div className="text-justify my-2 p-2 leading-relaxed" title="">
              {translations[language].cardTextOne}
            </div>
          </div>
          <div className="w-full sm:w-1/2 lg:w-1/3 flex">
            <img src={qrCode} alt="Grub screw" title="" className="object-cover w-[300px] h-[300px]" />
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-md my-4">
          <h2 className="text-xl font-bold mb-3">
            {contactTranslations[language].title}
          </h2>

          <div className="mb-2">
            <span className="font-medium">
              {contactTranslations[language].father}:
            </span>{' '}
            <span className="text-blue-700 font-semibold"></span>
          </div>

          <div>
            <span className="font-medium">
              {contactTranslations[language].son}:
            </span>{' '}
            <span className="text-blue-700 font-semibold">+91-9356028350</span>
          </div>

          <div>
            <span className="font-medium">
              {contactTranslations[language].sonOne}:
            </span>{' '}
            <span className="text-blue-700 font-semibold">+91-9657788346</span>
          </div>
        </div>

      </div>
    </div>
  );
}

export default App;
